
export interface ITaskState {
    hasDownloaded: boolean;
}

export class TaskState implements ITaskState {
    public hasDownloaded: boolean = false;
}


// WEBPACK FOOTER //
// ./src/Store/Tasks/TaskState.ts